import React from 'react';

function Loading() {
    return (
        <div className="not_found">
            <h1>Loading...</h1>
            <div className='Powered'>
                <p><b>Powered by</b></p>
                <img src="/cs.png" alt='CS Club' />
            </div>
        </div>
    );
}

export default Loading;
